<template>
  <main class="policy-page">
    <h1>プライバシーポリシー</h1>

    <section>
      <h2>アクセス解析・広告について</h2>
      <p>
        当サイトでは、利便性の向上、利用状況の把握、広告配信のために Cookie などの技術を使用する場合があります。Cookie により個人を直接特定する情報を取得するものではありません。
      </p>
    </section>

    <section>
      <h2>広告配信サービスについて</h2>
      <p>
        当サイトでは、Google AdSense などの第三者配信広告サービスを利用する場合があります。広告配信事業者は、利用者の興味に応じた広告を表示するために Cookie を使用することがあります。
      </p>
    </section>

    <section>
      <h2>アフィリエイトプログラムについて</h2>
      <p>
        当サイトは、Amazon アソシエイトを含むアフィリエイトプログラムに参加する場合があります。対象リンクを経由した購入・申込により、当サイトが紹介料を受け取ることがあります。
      </p>
    </section>

    <section>
      <h2>免責事項</h2>
      <p>
        当サイトは非公式サイトです。掲載情報の正確性には注意していますが、最新情報や詳細は公式ブログ、公式チケットサイト、各サービス提供元をご確認ください。
      </p>
    </section>
  </main>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.policy-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 16px;
  color: #444;
  text-align: left;
}

.policy-page h1 {
  margin-bottom: 20px;
  color: #4a4a4a;
  font-size: 24px;
  text-align: center;
}

.policy-page h2 {
  margin: 24px 0 8px;
  color: #4a4a4a;
  font-size: 18px;
}

.policy-page p {
  line-height: 1.7;
}
</style>
